export enum RouteNameEnum {
  ConfirmEmail = 'confirmEmail',
  EmailVerification = 'emailVerification',
  AnonSurvey = 'anonSurvey',
  Certificates = 'certificates',
  CertificatePath = 'certificatePath',
  ComparisonTable = 'comparisonTable',
  Competences = 'competences',
  CompetenceEntry = 'competenceEntry',
  CompetenceSelfMarkSurvey = 'competenceSelfMarkSurvey',
  Dashboard = 'dashboard',
  Form = 'form',
  GamificationInit = 'gamificationInit',
  GamificationStart = 'gamificationStart',
  GamificationSurvey = 'gamificationSurvey',
  GamificationTask = 'gamificationTask',
  GamificationNews = 'gamificationNews',
  GamificationPoints = 'gamificationPoints',
  Idd = 'idd',
  KnowledgeBase = 'knowledgeBase',
  KnowledgeBaseLesson = 'knowledgeBaseLesson',
  News = 'news',
  NewsEntry = 'newsEntry',
  Notifications = 'notifications',
  Onboarding = 'onboarding',
  ProfileEdit = 'profileEdit',
  ProfileDetails = 'profileDetails',
  ProfileAgreementsAndCookies = 'profileAgreementsAndCookies',
  ProfileAgreements = 'profileAgreements',
  ProfileCookies = 'profileCookies',
  ProfilePasswords = 'profilePasswords',
  ProfileDocuments = 'profileDocuments',
  ProfileFacsimile = 'profileFacsimile',
  ProfileArchives = 'profileArchives',
  Surveys = 'surveys',
  TeamIndicatorsStrategic = 'teamIndicatorsStrategic',
  TeamIndicatorsCommon = 'teamIndicatorsCommon',
  TeamIndicatorsStatistics = 'teamIndicatorsStatistics',
  Trainings = 'trainings',
  TrainingDetails = 'trainingDetails',
  VideoPlayer = 'videoPlayer',
  NotFound = 'notFound',
  Registration = 'registration',
  AccountActivation = 'accountActivation',
  RemindPassword = 'remindPassword',
  SignIn = 'signIn',
  ContactDataConfirm = 'contactDataConfirm',
  PreAccountRegistration = 'preAccountRegistration',
  Regulations = 'regulations',
  PrivacyPolicy = 'privacyPolicy',
  InformationDuty = 'informationDuty',
  TrainingRegulations = 'trainingRegulations',
  UsersAdministrationDashboard = 'usersAdministrationDashboard',
  UsersAdministrationCompaniesList = 'usersAdministrationCompaniesList',
  UsersAdministrationUserDetails = 'usersAdministrationUserDetails',
  UsersAdministrationUsersList = 'usersAdministrationUsersList',
  UsersAdministrationCompanyDashboard = 'usersAdministrationCompanyDashboard',
  UsersAdministrationCyclicalLessons = 'usersAdministrationCyclicalLessons',
  UsersAdministrationCourses = 'usersAdministrationCourses',
  SubstitutionCreate = 'substitutionCreate',
  SubstitutionsDashboard = 'substitutionsDashboard',
  SubstitutionsList = 'substitutionsList',
  LegalFormEdit = 'legalFormEdit',
  LegalFormsAttemptsList = 'legalFormsAttemptsList',
  IncomingAuth = 'incomingAuth'
}
